import credentialsAPI from '@api/credentials'
import type { ResetPasswordRequest } from '@api/credentials'
import { makeMutation } from '@lib/mutation'

interface ResetPasswordMutationRequest extends ResetPasswordRequest {
  retailerPartnerNumber: number
}

export const useResetPassword = makeMutation<ResetPasswordMutationRequest, void>({
  key: 'resetPassword',
  loader: async ({ retailerPartnerNumber, ...body }) => await credentialsAPI.resetPassword(body, retailerPartnerNumber),
})
